import { fetchFromLambda } from '@agyletime/vue-3-common/src/utils/apiService';
import { ApiQueryParams } from '@/pages/OperationsInsights/types/ApiQueryParams';
import {
    ApiRespBacklogAgeBandsBucketsByWorkstreams,
    BacklogAgeBandBucketsByWorkstream
} from '@/pages/OperationsInsights/types/BacklogMetricsResponse';
import { transformDateIntoLocalString } from '@/utils';

const enrichBacklogAgeBandsBucketsByWorkstreams = (metric: BacklogAgeBandBucketsByWorkstream) => {
    // age band metric by workstream
    let latestIntervalByWorkstream: number;
    metric.ageBandsBuckets.forEach((ageBandItemsByName) => {
        ageBandItemsByName.ageBandMetricsBuckets.forEach((bucketItem) => {
            bucketItem.bucket = new Date(bucketItem.bucket);
        });

        // sort all buckets for each ageBandName
        ageBandItemsByName.ageBandMetricsBuckets.sort((a, b) => a.bucket.getTime() - b.bucket.getTime());
        ageBandItemsByName.lastIntervalOpenCount = ageBandItemsByName.ageBandMetricsBuckets.at(-1)!.openCount;

        // calculate netChangesOpenCount by age band and workstream
        const firstIntervalOpenCount = ageBandItemsByName.ageBandMetricsBuckets.at(0)!.openCount;
        ageBandItemsByName.netChangesOpenCount = ageBandItemsByName.lastIntervalOpenCount - firstIntervalOpenCount;

        // logic to inject zero for the last data point by workstream
        if (!latestIntervalByWorkstream) {
            latestIntervalByWorkstream = ageBandItemsByName.ageBandMetricsBuckets.at(-1)!.bucket.getTime();
        } else {
            if (latestIntervalByWorkstream < ageBandItemsByName.ageBandMetricsBuckets.at(-1)!.bucket.getTime() ) {
                latestIntervalByWorkstream = ageBandItemsByName.ageBandMetricsBuckets.at(-1)!.bucket.getTime();
            }
        }

    });

    // injecting of zero on the last data point for the workstream
    metric.ageBandsBuckets.forEach((ageBandItemsByName) => {
        if (latestIntervalByWorkstream && latestIntervalByWorkstream !== ageBandItemsByName.ageBandMetricsBuckets.at(-1)!.bucket.getTime()) {
            ageBandItemsByName.ageBandMetricsBuckets.push({
                bucket: new Date(latestIntervalByWorkstream),
                openCount: 0
            });
            ageBandItemsByName.lastIntervalOpenCount = 0;
            // recalculate netChangesOpenCount (make it negative based on lastInterval val - firstInterval val
            ageBandItemsByName.netChangesOpenCount = ageBandItemsByName.ageBandMetricsBuckets.at(0)!.openCount * -1;
        }
    });
};
export const fetchBacklogAgeBandsBucketsByWorkstreams =
    async (params: ApiQueryParams): Promise<ApiRespBacklogAgeBandsBucketsByWorkstreams> => {
        const fromDate = transformDateIntoLocalString(params.fromDate);
        const toDate = transformDateIntoLocalString(params.toDate);
        const fetchUrl =
        '/workactivity/back-office/backlog/snapshot/age-bands/buckets/workstreams?' +
        `fromDate=${fromDate}&toDate=${toDate}&workstreamDefinitionIds=${params.workstreamDefinitionIds.join(',')}`;
        const resp: ApiRespBacklogAgeBandsBucketsByWorkstreams = await fetchFromLambda(fetchUrl);

        // initialise date
        if (resp.metrics?.length) {
            for (const metric of resp.metrics) {
                enrichBacklogAgeBandsBucketsByWorkstreams(metric);
            }
        }
        return resp as ApiRespBacklogAgeBandsBucketsByWorkstreams;
    };
